import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from './AuthContext';
import OnboardingGate from './OnboardingGate';
import {
  isQuestionDetailPath,
  rememberPostLoginRedirect,
  resolvePostLoginDestination,
} from '../../config/routes';
import { getAccessToken } from '../../utils/authTokenStore';

const ProtectedRoute = ({ element, skipOnboarding }) => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();
  const hasProfile = Boolean(localStorage.getItem('userProfile'));
  const questionDeepLink = isQuestionDetailPath(location.pathname);
  const hasSessionHint = isAuthenticated || hasProfile || Boolean(getAccessToken());
  const canRenderWhileAuthRefresh = questionDeepLink && hasSessionHint;

  if (isLoading && !canRenderWhileAuthRefresh) {
    return <div className="loading-spinner" aria-label="Loading" />;
  }

  if (!hasSessionHint) {
    const returnPath = resolvePostLoginDestination(location.pathname + location.search);
    rememberPostLoginRedirect(returnPath);
    const redirect = encodeURIComponent(returnPath);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (skipOnboarding || questionDeepLink) {
    return element;
  }

  return <OnboardingGate>{element}</OnboardingGate>;
};

export default ProtectedRoute;
